import styled from 'styled-components/macro';

export const WrapperSpinner = styled.div`
	align-items: center;
	display: flex;
	height: 100vh;
	justify-content: center;
	width: 100%;
`;
